import React, {ReactNode} from 'react';
import Card from '../ui/Card';
import {Lock} from 'lucide-react';

const DEFAULT_TITLE = 'غير مصرح لك بالوصول';
const DEFAULT_MESSAGE =
  'ليس لديك الصلاحيات اللازمة لعرض هذه الصفحة.';

export interface PermissionDeniedCardProps {
  /** Optional title. Default: Arabic "غير مصرح لك بالوصول" */
  title?: string;
  /** Optional message. Default: Arabic permission message */
  message?: string;
  /** Optional icon (ReactNode). Default: Lock icon in styled container */
  icon?: ReactNode;
  /** Optional extra class for the outer wrapper */
  className?: string;
}

/**
 * Reusable card shown when the user lacks permission to view a page/section.
 * Styled consistently with existing cards (padding, centered, icon).
 */
const PermissionDeniedCard: React.FC<PermissionDeniedCardProps> = ({
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  icon,
  className = ''
}) => {
  const iconContent = icon ?? (
    <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <Lock className="w-8 h-8 text-yellow-700" />
    </div>
  );

  return (
    <Card className={`p-6 ${className}`}>
      <div className="text-center py-12">
        {iconContent}
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600">{message}</p>
      </div>
    </Card>
  );
};

export default PermissionDeniedCard;
